import { render, staticRenderFns } from "./LottieFoxyHappyCard.vue?vue&type=template&id=53e3b0c6&scoped=true&"
import script from "./LottieFoxyHappyCard.vue?vue&type=script&lang=js&"
export * from "./LottieFoxyHappyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e3b0c6",
  null
  
)

export default component.exports